export default __webpack_public_path__ + "static/media/github.748c24f4.png";